<template>
	<h2 v-tw-class="'font-headings font-semibold text-h2'">
		<slot />
	</h2>
</template>
